import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'
import {FormControl, TextInput, useFormControlForwardedProps} from '@primer/react'

import styles from './NewBranchName.module.css'
import {clsx} from 'clsx'

export function NewBranchName({
  ref,
  newBranchName,
  setNewBranchName,
}: {
  newBranchName: string
  setNewBranchName: (newName: string) => void
  ref?: React.Ref<HTMLInputElement>
}) {
  return (
    <FormControl>
      <FormControl.Label>New branch name</FormControl.Label>
      <div className={styles.NewBranchNameInputGroup}>
        <BranchNameInput ref={ref} newBranchName={newBranchName} setNewBranchName={setNewBranchName} />
        <div className={clsx('color-bg-subtle', styles.copyButtonContainer)}>
          <CopyToClipboardIconButton
            tooltipProps={{direction: 'nw'}}
            textToCopy={newBranchName}
            ariaLabel="Copy to clipboard"
            className={clsx(styles.CopyToClipboardIconButton)}
          />
        </div>
      </div>
    </FormControl>
  )
}

function BranchNameInput({
  ref,
  newBranchName,
  setNewBranchName,
}: {
  newBranchName: string
  setNewBranchName: (newName: string) => void
  ref?: React.Ref<HTMLInputElement>
}) {
  const forwardedProps = useFormControlForwardedProps({})
  return (
    <TextInput
      block
      {...forwardedProps}
      className={clsx('color-bg-subtle', styles.TextInput)}
      value={newBranchName}
      onChange={e => setNewBranchName(e.target.value)}
      ref={ref}
    />
  )
}
